import { render, staticRenderFns } from "./SkeletonLine.vue?vue&type=template&id=2044a52c&scoped=true&"
import script from "./SkeletonLine.vue?vue&type=script&lang=js&"
export * from "./SkeletonLine.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonLine.vue?vue&type=style&index=0&id=2044a52c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2044a52c",
  null
  
)

export default component.exports